export default {
  namespaced: true,
  state: {
    show: false,
    title: "",
    description: "",
  },
  getters: {},
  mutations: {
    show(state, { title, description }) {
      state.show = true;
      state.title = title;
      state.description = description;
    },
    close(state) {
      state.show = false;
      state.title = "";
      state.description = "";
    },
  },
  actions: {},
};
